import React from "react";
import { RemoveSupplyContext } from "src/context/RemoveSupplyFormContext";
import {
  FileUploadFormikField,
  FileUploadFormikFieldProps,
} from "src/components/Fields/FileUpload";

export const RemoveSupplyFormFileUploadFormikField: React.FC<
  Omit<FileUploadFormikFieldProps, "setDisplayingSnackbar">
> = (props) => {
  const { setDisplayingSnackbar } = React.useContext(RemoveSupplyContext);
  return (
    <FileUploadFormikField
      {...props}
      setDisplayingSnackbar={setDisplayingSnackbar}
    />
  );
};
